import React, { useState } from 'react';
import styles from './small-loading-dots.module.sass';

const SmallLoadingDots = () => {
  return (
    <svg
      className={styles.fadeOutHalf}
      role="status"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 300 100"
    >
      <circle r="12%" cx="20%" cy="50%" color="#000" />
      <circle r="12%" cx="50%" cy="50%" color="#000" />
      <circle r="12%" cx="80%" cy="50%" color="#000" />
    </svg>
  );
};

export default SmallLoadingDots;
